function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 5.688a5.811 5.811 0 015.812 5.812A5.811 5.811 0 0112 17.312 5.811 5.811 0 016.187 11.5 5.811 5.811 0 0112 5.688zm0 10.5a4.686 4.686 0 004.687-4.688A4.686 4.686 0 0012 6.813 4.686 4.686 0 007.312 11.5 4.686 4.686 0 0012 16.187zm1.448-2.447l-1.99-1.446a.283.283 0 01-.114-.228V8.22c0-.155.126-.281.281-.281h.75c.155 0 .281.126.281.28v3.322l1.566 1.139a.281.281 0 01.06.394l-.44.607a.283.283 0 01-.394.06z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgStatusScheduledIcon = function SvgStatusScheduledIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgStatusScheduledIcon;